export const ACTIVITIES_PROMPT_NAME = 'detailedActivities';
export const ACTIVITIES_PROMPT_NAME_DEFAULT = 'Activity';
export const ACTIVITIES_PROMPT_NAME_AMERICAN = 'americanActivity';
